import { getEnvironment } from 'src/config';
import { Environment } from 'src/types';

export const isLocalDev = () => getEnvironment() === Environment.DEV;

export const isStaging = () => getEnvironment() === Environment.STAGING;

export const isProd = () => getEnvironment() === Environment.PROD;
